module.exports = __webpack_public_path__ + "img/RB.a3c49c6d.svg";